/* eslint-disable max-len */
import React from 'react';
import { Controller } from 'react-hook-form';
import {
  FormFeedback,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import CustomSelect from '../CustomSelect';
import MoneyMaskedInput from '../MoneyMaskedInput';

export function toUpperCasePtBr(raw) {
  if (raw == null) return '';
  return raw.toLocaleUpperCase('pt-BR');
}

const TIPO_DOCUMENTO_OPTIONS = [
  { value: 'NOTA FISCAL', label: 'NOTA FISCAL' },
  { value: 'CUPOM FISCAL', label: 'CUPOM FISCAL' },
  { value: 'RECIBO', label: 'RECIBO' },
];

function ReembolsoFormFields({
  control,
  errors,
  responsavelTipo,
  formaPagamento,
  clientes,
  loadingClientes,
}) {
  return (
    <>
      <Controller
        name="formaPagamento"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Forma de Pagamento (*)</Label>
            <div className="d-flex flex-column">
              <FormGroup check className="mb-2">
                <Label check>
                  <Input
                    type="radio"
                    name="formaPagamento"
                    checked={field.value === 'nicash'}
                    onChange={() => field.onChange('nicash')}
                  />
                  CARTÃO COORPORATIVO
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="formaPagamento"
                    checked={field.value === 'reembolso'}
                    onChange={() => field.onChange('reembolso')}
                  />
                  REEMBOLSO/CARTÃO PESSOAL
                </Label>
              </FormGroup>
            </div>
            <FormFeedback style={{ display: errors?.formaPagamento?.message ? 'block' : 'none' }}>
              {errors?.formaPagamento?.message}
            </FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="responsavelTipo"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Responsável pelo gasto (*)</Label>
            <div className="d-flex flex-column">
              <FormGroup check className="mb-2">
                <Label check>
                  <Input
                    type="radio"
                    name="responsavelTipo"
                    checked={field.value === 'nic_sp'}
                    onChange={() => field.onChange('nic_sp')}
                  />
                  NIC São Paulo
                </Label>
              </FormGroup>
              <FormGroup check className="mb-2">
                <Label check>
                  <Input
                    type="radio"
                    name="responsavelTipo"
                    checked={field.value === 'nic_go'}
                    onChange={() => field.onChange('nic_go')}
                  />
                  NIC Goiania
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="responsavelTipo"
                    checked={field.value === 'paciente'}
                    onChange={() => field.onChange('paciente')}
                  />
                  Paciente/Cliente/Família
                </Label>
              </FormGroup>
            </div>
            <FormFeedback style={{ display: errors?.responsavelTipo?.message ? 'block' : 'none' }}>
              {errors?.responsavelTipo?.message}
            </FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="cliente"
        control={control}
        render={({ field }) => (
          <CustomSelect
            label="Responsável pelo gasto"
            placeholder="Selecione o responsável pelo gasto"
            loading={loadingClientes}
            loadingMessage={() => 'Carregando pacientes...'}
            noOptionsMessage={() => 'Nenhum paciente encontrado'}
            invalidMessage={errors?.cliente?.message}
            isDisabled={responsavelTipo === 'nic_sp' || responsavelTipo === 'nic_go'}
            {...field}
            options={clientes}
          />
        )}
      />
      <Controller
        name="descricao"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Descrição do item Comprado</Label>
            <Input
              type="textarea"
              placeholder="Descreva o item comprado"
              value={field.value}
              maxLength={40}
              invalid={!!errors?.descricao?.message}
              onChange={(e) => field.onChange(toUpperCasePtBr(e.target.value))}
            />
            <div className="d-flex justify-content-end">
              <small className="text-muted">
                {(field.value || '').length}
                /40
              </small>
            </div>
            <FormFeedback>{errors?.descricao?.message}</FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="valor"
        control={control}
        render={({ field }) => (
          <MoneyMaskedInput
            label="Valor da Compra"
            invalidMessage={errors?.valor?.message}
            value={field.value}
            onValueChange={({ floatValue }) => field.onChange(floatValue)}
          />
        )}
      />
      <Controller
        name="dataCompra"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Data da Compra</Label>
            <Input
              type="date"
              placeholder="Informe a data da compra"
              value={field.value}
              invalid={!!errors?.dataCompra?.message}
              onChange={(e) => field.onChange(e.target.value)}
            />
            <FormFeedback>{errors?.dataCompra?.message}</FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="localCompra"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Local da Compra</Label>
            <Input
              type="text"
              placeholder="Informe o nome do estabelecimento"
              value={field.value}
              maxLength={40}
              invalid={!!errors?.localCompra?.message}
              onChange={(e) => field.onChange(toUpperCasePtBr(e.target.value))}
            />
            <div className="d-flex justify-content-end">
              <small className="text-muted">
                {(field.value || '').length}
                /40
              </small>
            </div>
            <FormFeedback>{errors?.localCompra?.message}</FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="autorizadoPor"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Autorizado por</Label>
            <Input
              type="text"
              placeholder="Informe o nome do Pai, Mãe, Ana, Luana, Mariana, Nome do supervisor(a) do caso"
              value={field.value}
              maxLength={20}
              invalid={!!errors?.autorizadoPor?.message}
              onChange={(e) => field.onChange(e.target.value)}
            />
            <div className="d-flex justify-content-end">
              <small className="text-muted">
                {(field.value || '').length}
                /20
              </small>
            </div>
            <FormFeedback>{errors?.autorizadoPor?.message}</FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="tipoDocumento"
        control={control}
        render={({ field }) => (
          <CustomSelect
            label="TIPO DE DOCUMENTO (*)"
            placeholder="Selecione o tipo de documento"
            invalidMessage={errors?.tipoDocumento?.message}
            {...field}
            options={TIPO_DOCUMENTO_OPTIONS}
          />
        )}
      />
      <Controller
        name="numeroDocumento"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label>Número do documento (*)</Label>
            <Input
              type="text"
              placeholder="Informe o número do documento"
              value={field.value}
              maxLength={15}
              invalid={!!errors?.numeroDocumento?.message}
              onChange={(e) => field.onChange(e.target.value)}
            />
            <div className="d-flex justify-content-end">
              <small className="text-muted">
                {(field.value || '').length}
                /15
              </small>
            </div>
            <FormFeedback>{errors?.numeroDocumento?.message}</FormFeedback>
          </FormGroup>
        )}
      />
      <Controller
        name="ultimosNumerosCartao"
        control={control}
        render={({ field }) => {
          if (formaPagamento === 'reembolso') {
            return null;
          }

          return (
            <FormGroup>
              <Label>4º ÚLTIMOS NUMEROS DO CARTÃO UTILIZADO (*)</Label>
              <Input
                type="text"
                placeholder="Informe os últimos números do cartão"
                value={field.value}
                maxLength={6}
                inputMode="numeric"
                invalid={!!errors?.ultimosNumerosCartao?.message}
                onChange={(e) => {
                  const v = (e.target.value || '').replace(/\D/g, '').slice(0, 6);
                  field.onChange(v);
                }}
              />
              <div className="d-flex justify-content-end">
                <small className="text-muted">
                  {(field.value || '').length}
                  /6
                </small>
              </div>
              <FormFeedback>{errors?.ultimosNumerosCartao?.message}</FormFeedback>
            </FormGroup>
          );
        }}
      />
      <Controller
        name="file"
        control={control}
        render={({ field }) => (
          <FormGroup>
            <Label for="comprovante-reembolso">Enviar Comprovante (*)</Label>
            <Input
              id="comprovante-reembolso"
              type="file"
              placeholder="Comprovante"
              accept="image/*"
              invalid={!!errors?.file?.message}
              onChange={({ target: { files } }) => field.onChange(files[0])}
            />
            <FormFeedback style={{ display: errors?.file?.message ? 'block' : 'none' }}>
              {errors?.file?.message}
            </FormFeedback>
          </FormGroup>
        )}
      />
    </>
  );
}

export default ReembolsoFormFields;
